import { Controller, useFormContext } from "react-hook-form";
import type { TopicsPickerProps } from "@circle-react/components/QuickPostV2/Content/TopicsPicker";
import { TopicsPicker } from "@circle-react/components/QuickPostV2/Content/TopicsPicker";
import { TopicsPicker as TopicsPickerLegacy } from "@circle-react/components/QuickPostV2/Content/TopicsPickerLegacy";
import { usePunditUserContext } from "@circle-react/contexts";

interface FormTopicsPickerProps extends TopicsPickerProps {
  name: string;
  rules?: any;
}

export const FormTopicsPicker = ({
  name,
  rules,
  ...rest
}: FormTopicsPickerProps) => {
  const { control } = useFormContext();
  const { currentCommunitySettings } = usePunditUserContext();

  const isNewTopicsPickerEnabled =
    !!currentCommunitySettings?.cms_topics_picker_backend_filtering_enabled;

  const Component = isNewTopicsPickerEnabled
    ? TopicsPicker
    : TopicsPickerLegacy;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <Component value={field.value} onChange={field.onChange} {...rest} />
      )}
    />
  );
};
